export const DEFAULT_HEADERS = {
  'Content-Type': 'application/json'
};


export const UPLOAD_FILE_HEADERS = {
  'Content-Type': 'multipart/form-data'
};
